import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield (hash Query=(component \"billing/cost-estimator/query\"))}}")